import { _t } from 'core/language';
import React from 'react';

interface EmptyDataProps {
  message: string;
  icon?: string;
  classNameText?: string;
  className?: string;
}

const EmptyData: React.FC<EmptyDataProps> = ({ message, icon, classNameText, className }) => {
  return (
    <div className="w-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
      <div className={`w-full text-center ${className}`}>
        {icon ? <img src={icon} 
          alt="" 
          className="mx-auto mb-[26px] mt-0"
        /> : ''}
        <label className={`w-full mb-5 font-medium text-[15px] ${classNameText}`} dangerouslySetInnerHTML={{__html: _t(message)}}>
          
        </label>
      </div>
    </div>
  );
};

export default EmptyData;